"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocale = exports.getLocaleFromRequest = void 0;
const constants_1 = require("./constants");
const cookies_1 = require("./cookies");
const headers_1 = require("./headers");
const tld_1 = require("./tld");
const url_1 = require("./url");
const webapp_constants_1 = require("@eventbrite/webapp-constants");
/**
 * Determines the locale based on a series of prioritized checks.
 *
 * @param {() => string | undefined} checks - A list of functions that return a locale or undefined.
 * @returns {string} - The first valid locale found, or the default locale.
 */
const determineLocale = (checks) => {
    for (const check of checks) {
        const locale = check();
        if (locale) {
            return locale;
        }
    }
    return constants_1.DEFAULT_LOCALE;
};
/**
 * Extracts the locale from an HTTP request using various sources of information.
 *
 * @param {IncomingMessage} request - The incoming HTTP request.
 * @returns {string} - The determined locale.
 */
const getLocaleFromRequest = (request) => {
    return determineLocale([
        () => (0, cookies_1.getLocaleFromCookie)(request.headers.cookie || ""),
        () => {
            const url = new URL(request.url, `https://${request.headers.host}`);
            return (0, url_1.getLocaleFromUrl)(url);
        },
        () => (0, tld_1.getLocaleFromTLD)(request),
        () => (0, headers_1.getLocaleFromHeaders)(request.headers),
    ]);
};
exports.getLocaleFromRequest = getLocaleFromRequest;
/**
 * Extracts the locale from a request object containing headers and optional search parameters.
 *
 * @typedef {Object} GetLocaleRequest
 * @property {Headers} headers - The headers of the request.
 * @property {URLSearchParams} [searchParams] - Optional URLSearchParams query parameters.
 *
 * @param {GetLocaleRequest} request - The request object.
 * @returns {string} - The determined locale.
 */
const getLocale = ({ headers, searchParams }) => {
    return determineLocale([
        () => (0, cookies_1.getLocaleFromCookie)(headers.get("cookie") || ""),
        () => (searchParams ? (0, url_1.getLocaleFromSearchParams)(searchParams) : null),
        () => (0, tld_1.getLocaleFromHostHeader)(headers.get(webapp_constants_1.EventbriteHeader.EB_HOST)),
        () => (0, headers_1.getLocaleFromAcceptLanguageHeader)(headers.get(headers_1.ACCEPT_LANGUAGE_HEADER) || ""),
    ]);
};
exports.getLocale = getLocale;
//# sourceMappingURL=request.js.map